document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("mousemove", (e) => {
    const x = e.clientX / window.innerWidth;
    const y = e.clientY / window.innerHeight;

    const blob1 = document.querySelector(".zp-blob-1");
    const blob2 = document.querySelector(".zp-blob-2");

    if (blob1 && blob2) {
      blob1.style.transform = `translate(${x * 30}px, ${y * 30}px)`;
      blob2.style.transform = `translate(${x * -40}px, ${y * -40}px)`;
    }
  });
});
